// Vendored directly from https://github.com/vuejs/vue/blob/master/src/core/util/debug.js with types only changes.
var classifyRE = /(?:^|[-_])(\w)/g;

var classify = function classify(str) {
  return str.replace(classifyRE, function (c) {
    return c.toUpperCase();
  }).replace(/[-_]/g, '');
};

var ROOT_COMPONENT_NAME = '<Root>';
var ANONYMOUS_COMPONENT_NAME = '<Anonymous>';

var repeat = function repeat(str, n) {
  // string.repeat() is not supported by IE11, we fall back to just using the string in that case
  // eslint-disable-next-line @sentry-internal/sdk/no-unsupported-es6-methods
  return str.repeat ? str.repeat(n) : str;
};

var formatComponentName = function formatComponentName(vm, includeFile) {
  if (!vm) {
    return ANONYMOUS_COMPONENT_NAME;
  }

  if (vm.$root === vm) {
    return ROOT_COMPONENT_NAME;
  } // https://github.com/getsentry/sentry-javascript/issues/5204 $options can be undefined


  if (!vm.$options) {
    return ANONYMOUS_COMPONENT_NAME;
  }

  var options = vm.$options;
  var name = options.name || options._componentTag;
  var file = options.__file;

  if (!name && file) {
    var match = file.match(/([^/\\]+)\.vue$/);

    if (match) {
      name = match[1];
    }
  }

  return (name ? "<".concat(classify(name), ">") : ANONYMOUS_COMPONENT_NAME) + (file && includeFile !== false ? " at ".concat(file) : '');
};

var generateComponentTrace = function generateComponentTrace(vm) {
  if (vm && (vm._isVue || vm.__isVue) && vm.$parent) {
    var tree = [];
    var currentRecursiveSequence = 0;

    while (vm) {
      if (tree.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var last = tree[tree.length - 1]; // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

        if (last.constructor === vm.constructor) {
          currentRecursiveSequence++;
          vm = vm.$parent; // eslint-disable-line no-param-reassign

          continue;
        } else if (currentRecursiveSequence > 0) {
          tree[tree.length - 1] = [last, currentRecursiveSequence];
          currentRecursiveSequence = 0;
        }
      }

      tree.push(vm);
      vm = vm.$parent; // eslint-disable-line no-param-reassign
    }

    var formattedTree = tree.map(function (vm, i) {
      return "".concat((i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm) ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)") : formatComponentName(vm)));
    }).join('\n');
    return "\n\nfound in\n\n".concat(formattedTree);
  }

  return "\n\n(found in ".concat(formatComponentName(vm), ")");
};

export { formatComponentName, generateComponentTrace };